export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5039.3b63a8a5.jpg";